import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'jalali-moment';

@Pipe({
    name: 'dateConverter'
})
export class DateConverterPipe implements PipeTransform {

    transform(value: string, type: string = 'ONLYDATE', format: string = null) {
        if (value) {
            if (type.toUpperCase() == 'ONLYDATE') {
                return moment(value).locale('fa').format(format ? format : 'YYYY-MM-DD');
            } else if (type.toUpperCase() == 'DATETIME') {
                return moment(value).locale('fa').format(format ? format : 'YYYY-MM-DD HH:mm:ss');
            } else if (type.toUpperCase() == 'ONLYTIME') {
                return moment(value).locale('fa').format(format ? format : 'HH:mm:ss');
            }
        }
        return null;
    }

}
